import React, { useEffect, useState } from 'react';
import { NavLink } from 'react-router-dom';
import '../../assets/styles/dark.css';
import BannerLogoLight from '../../assets/images/BHGC_250x250.png'
import LogoLight from '../../assets/images/BHGC_70.png';
import swal from 'sweetalert2';
import * as helper from '../global/helper';
import { getAdminMenu } from '../api/adminAPI';
import { useHistory } from 'react-router-dom';
import DOMPurify from 'dompurify';

const sideMenu = (props) => {

    const [menuList,        setMenuList]       = useState([]);
    const [subMenuList,     setSubMenuList]    = useState([]);
    const history 							   = useHistory();

    useEffect(() => {
        $('.kt-menu__item').removeClass('kt-menu__item--active');
        if (props.menuID) $('#' + props.menuID).addClass('kt-menu__item--active');
    });

    useEffect(() => {
        fetchAdminMenu()

        // Run the merged initializer once the component is in the DOM
        if (window.initMetronicMenu) {
            window.initMetronicMenu('#kt_aside_menu');
        }        
    },[])

    useEffect(() => {
       if (props.menuID && subMenuList.length > 0 && !subMenuList.find(f => f.Url === props.menuID)) {
            history.push(subMenuList[0].Url);      
       }
    },[props.menuID])

    useEffect(() => {
        if (menuList.length > 0) {
            $('.kt-menu__item').off('click');

            $('.kt-menu__item').on('click', function (e) {
                if ($(e.target).closest('.ddlSubmenu').length) return;

                const item = $(this);
                if ($('body').hasClass('kt-aside--minimize')) {
                    e.preventDefault();
                    e.stopPropagation();

                    const subMenu = item.find('.ddlSubmenu');
                    const isAlreadyOpen = subMenu.hasClass('show');

                    $('.ddlSubmenu').removeClass('show').css('display', 'none');

                    if (!isAlreadyOpen) {
                        const rect = this.getBoundingClientRect(); 
                        const windowHeight = $(window).height();
                        
                        // 1. DYNAMIC HEIGHT CALCULATION
                        // Temporarily show to measure real height
                        subMenu.css({ 'display': 'block', 'visibility': 'hidden', 'height': 'auto' });
                        const actualHeight = subMenu[0].scrollHeight;
                        const effectiveHeight = actualHeight > 350 ? 350 : actualHeight;
                        subMenu.css({ 'display': 'none', 'visibility': 'visible' });

                        let topPos = rect.top;

                        // 2. SMART OVERFLOW
                        // Only push up by the actual height of the menu, not a hardcoded 350
                        if (topPos + effectiveHeight > windowHeight) {
                            topPos = windowHeight - effectiveHeight - 10;
                        }

                        // Ensure it doesn't go off the top of the screen either
                        if (topPos < 10) topPos = 10;

                        subMenu.css({
                            'position': 'fixed',
                            'top': topPos + 'px',
                            'left': '70px',
                            'display': 'block',
                            'max-height': '350px',
                            'height': 'auto' 
                        });

                        subMenu.addClass('show');

                        // 3. MOUSE WHEEL SCROLL FIX
                        // Stop the wheel event from bubbling up to Metronic's sidebar
                        subMenu.off('wheel').on('wheel', function(e) {
                            const event = e.originalEvent;
                            const scrollTop = this.scrollTop;
                            const scrollHeight = this.scrollHeight;
                            const height = $(this).height();
                            const delta = event.deltaY;

                            // Allow scrolling inside, but block if at top/bottom to prevent sidebar movement
                            if ((delta < 0 && scrollTop <= 0) || (delta > 0 && scrollTop + height >= scrollHeight)) {
                                e.preventDefault();
                            }
                            e.stopPropagation(); 
                        });
                    }
                }
            });

            const handleOutsideClick = (e) => {
                if (!$(e.target).closest('.kt-menu__item').length) {
                    $('.ddlSubmenu').removeClass('show').css('display', 'none');
                }
            };

            $(document).on('click', handleOutsideClick);
            return () => {
                $(document).off('click', handleOutsideClick);
                $('.kt-menu__item').off('click');
            };
        }
    }, [menuList]);

    useEffect(() => {
        if (subMenuList.length > 0 && !props.menuID) {
            props.title(subMenuList[0].Name, subMenuList[0].Url)
        }
    },[subMenuList])
    

    const toggleSubMenu = (e) => {
        e.preventDefault();
        
        // ~ Get the body element
        const body = document.body;
        
        // ~ Toggle the Metronic Minimize Class
        // This is the most important line missing from your code
        if (body.classList.contains('kt-aside--minimize')) {
            body.classList.remove('kt-aside--minimize'); // Expand
        } else {
            body.classList.add('kt-aside--minimize');    // Minimize
        }

        // ~ Handle Cosmetic Changes (Logos & Classes)
        if (body.classList.contains('kt-aside--minimize')) {
           
            $('.kt-aside__brand-tools').addClass('aside-brand-tools');
            $('#asideBrandLogo').attr('src', LogoLight);
            $('#asideBrandLogo').attr('height', '35');
            
            // Add tooltips for minimized state
            $('.kt-menu__link-text').each(function() {
                // Find parent link and set title
                const text = $(this).text();
                $(this).closest('.kt-menu__link').attr('title', text);
            });
            
        } else {
            $('.kt-aside__brand-tools').removeClass('aside-brand-tools');
            $('#asideBrandLogo').attr('src', BannerLogoLight);
            $('#asideBrandLogo').attr('height', '150');
            
            // Remove tooltips in expanded state
            $('.kt-menu__link').removeAttr('title');
        }

        // ~ CRITICAL: Re-initialize the Menu Logic
        // This forces the script to detect the new body class and switch modes
        if (window.initMetronicMenu) {
            // Use a small timeout to let the class change take effect before JS runs
            setTimeout(() => {
                window.initMetronicMenu('#kt_aside_menu');
            }, 100);
        }
    };

    const fetchAdminMenu = async() =>{
        try {
            const menu = await getAdminMenu()
            setMenuList(menu.menuList)
            setSubMenuList(menu.subMenuList)           
        } catch (error) {
            swal.fire({
                icon      : 'error',
                titleText : error.message
            })  
        }
    }

    return (
        <div className="kt-aside kt-aside--fixed  kt-grid__item kt-grid kt-grid--desktop kt-grid--hor-desktop" id="kt_aside">
            <div className="kt-aside__brand kt-grid__item" id="kt_aside_brand">
                <div className="kt-aside__brand-logo">
                    <NavLink disabled={props.disabled} to="/">
                        <img id="asideBrandLogo" alt="Logo" src={BannerLogoLight} height="150"/>
                    </NavLink>
                </div>
                <div className="kt-aside__brand-tools">
                    <button className="kt-aside__brand-aside-toggler" onClick={(e) => toggleSubMenu(e)} id="kt_aside_toggler">
                    <span>
                        <svg className="nav-movment" width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M13.706 9.698a.988.988 0 0 0 0-1.407 1.01 1.01 0 0 0-1.419 0l-2.965 2.94a1.09 1.09 0 0 0 0 1.548l2.955 2.93a1.01 1.01 0 0 0 1.42 0 .988.988 0 0 0 0-1.407l-2.318-2.297 2.327-2.307z" fill="currentColor" fillRule="evenodd"></path></svg>
                    </span>
                    <span>
                        <svg className="nav-movment margin-l65" width="24" height="24" viewBox="0 0 24 24" focusable="false" role="presentation"><path d="M10.294 9.698a.988.988 0 0 1 0-1.407 1.01 1.01 0 0 1 1.419 0l2.965 2.94a1.09 1.09 0 0 1 0 1.548l-2.955 2.93a1.01 1.01 0 0 1-1.42 0 .988.988 0 0 1 0-1.407l2.318-2.297-2.327-2.307z" fill="currentColor" fillRule="evenodd"></path></svg>
                    </span>
                    </button>
                </div>
            </div>
            <div className="kt-aside-menu-wrapper kt-grid__item kt-grid__item--fluid" id="kt_aside_menu_wrapper">
                <div id="kt_aside_menu" className="kt-aside-menu kt-scroll margin-t0" data-ktmenu-vertical="1" data-ktmenu-scroll="1" data-ktmenu-dropdown-timeout="500" 
                    style={{ 
                        height: 'calc(100vh - 70px)', // Dynamic height (Viewport - Header Height)
                        overflow: 'hidden',            // Hides native scrollbar
                        position: 'relative'           // Anchors the custom scrollbar
                    }}                   
                >
                    {menuList.length > 0 && (
                        <ul className="kt-menu__nav padding-t0">
                            {menuList.map((m, i) => (
                                <li id={helper.SanitizeUrl(m.Name)} key={i} className="kt-menu__item kt-menu__item--submenu dropdown" aria-haspopup="true" data-ktmenu-submenu-toggle="hover">
                                    <NavLink disabled={props.disabled} to={'/'+ m.Url} className="kt-menu__link kt-menu__toggle subMenuLink" aria-expanded='true'>
                                        <span className="kt-menu__link-icon" data-original-title={m.ID}  data-toggle="kt-tooltip" data-trigger="hover" data-placement="right">
                                            <span dangerouslySetInnerHTML={{__html: DOMPurify.sanitize(m.Icon)}}/>
                                        </span>
                                        <span className="kt-menu__link-text">{m.Name}</span>
                                        {m.Name != 'Dashboard' && (
                                            <i className="kt-menu__ver-arrow la la-angle-right"></i>   
                                        )}
                                    </NavLink>
                                    {/* <div className='dropdown-menu dropdown-menu-anim ddlSubmenu fixed'> */}
                                    <div className='dropdown-menu dropdown-menu-anim ddlSubmenu'>
                                        <ul className="kt-nav padding-0">
                                            <label className="submenuHeading mb-0">{m.Name}</label>
                                            <hr />
                                            {subMenuList.filter(f => f.ParentMenuID == m.MenuID).map((s, i) => (
                                                <li className="kt-nav__item" key={i}>
                                                    <NavLink to={'/'+s.Url} className="kt-nav__link">   
                                                        <span className="kt-nav__link-icon"><span className="bullet bullet-dot"></span></span>
                                                        <span className="kt-nav__link-text submenuTitle">{s.Name}</span>
                                                    </NavLink>
                                                </li>
                                            ))}
                                        </ul>
                                    </div>
                                    {m.Name != 'Dashboard' && (
                                        <>
                                            <div className="kt-menu__submenu" kt-hidden-height="80" style={{display:'none', overflow:'hidden'}}>
                                                <span className="kt-menu__arrow"></span>
                                                <ul className="kt-menu__subnav">
                                                    {subMenuList.filter(f => f.ParentMenuID == m.MenuID).map((s, i) => (
                                                        <li id={s.Url} className="kt-menu__item" key={i} >
                                                            <NavLink to={'/'+s.Url} className="kt-menu__link" >
                                                                <i className="kt-menu__link-bullet kt-menu__link-bullet--dot"><span></span></i>
                                                                <span className="kt-menu__link-text">{s.Name}</span>
                                                            </NavLink>
                                                        </li>
                                                    ))}
                                                </ul>
                                            </div>
                                        </>
                                    )}
                                </li>)

                            )}                           
                        </ul>
                    )}
                </div>
            </div>
        </div>
    );

};

export default sideMenu;


